(function () {

  'use strict';

  function pxOkta(IdpProviderService, IdpContextMenuMixin) {
    return {
      restrict: 'EA',
      scope: {
        tenant: '=',
        me: '='
      },
      templateUrl: 'app/components/authenticationSettings/okta/okta.template.html',
      link: function (scope) {
        scope.descriptor = IdpProviderService.descriptorByType('okta');
        scope.directories = IdpProviderService.directoriesFor(scope.tenant, 'okta');
        scope.redirectURI = IdpProviderService.redirectURIFor(scope.descriptor);
        scope.copyRedirectURI = function () {
          return IdpProviderService.copyRedirectURI(scope.descriptor);
        };
        IdpContextMenuMixin.attach(scope);
        IdpProviderService.attachListeners(scope, 'okta');
      }
    };
  }

  pxOkta.$inject = ['IdpProviderService', 'IdpContextMenuMixin'];

  angular
    .module('printix-admin')
    .directive('pxOkta', pxOkta);

})();
